<template>
  <div ref="dropzone">
    <div class="row mb-3">
      <div class="col d-flex align-items-center">
        <p class="mt-0 mb-0">
          <strong>Documents</strong>
        </p>
      </div>

      <div class="col-auto">
        <button v-if="$userIsAdmin" type="button" class="btn btn-sm btn-outline-info upload-button">
          <font-awesome :icon="['far', 'file-upload']" class="mr-2"/>
          Upload
          <span class="sr-only">new graduate profile document</span>
        </button>
      </div>
    </div>

    <ul id="dropzone-files" class="file-download"></ul>

    <div v-if="noDocuments" class="text-left text-muted mt-3 mb-4">
      No documents uploaded
    </div>

    <div id="dz-template" class="dz-template" ref="template">
      <li>
        <div class="row">
          <a href="" @click.prevent class="col download-file">
            <span class="filename truncate" data-dz-name></span>
          </a>

          <div class="col-auto">
            <a v-if="$userIsAdmin" href="#" class="remove-file">
              <font-awesome :icon="['far', 'trash']"/> Delete File
            </a>
          </div>
        </div>

        <div class="progress mt-2">
          <div class="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" data-dz-uploadprogress></div>
        </div>
      </li>
    </div>
  </div>
</template>

<style scoped>
.dz-template {
  display: none;
}
.progress.hidden,
.remove-file.hidden {
  display: none;
}
</style>

<script>
import { auth, apiUrl, alert } from 'utils'
import { graduateComputed, graduateMethods } from 'vx/helpers'
import { each } from 'lodash'
import $ from 'jquery'
import Dropzone from 'dropzone'
export default {
  computed: {
    ...graduateComputed,

    noDocuments () {
      return this.graduate.documents.length === 0
    }
  },

  mounted () {
    this.dz = new Dropzone(this.$refs.dropzone, {
      url: apiUrl('graduates/documents') + `&graduate_id=${this.graduate.id}`,
      withCredentials: true,
      maxFilesize: 5,
      acceptedFiles: '.pdf, .docx',
      clickable: this.$userIsAdmin ? '.upload-button' : false,
      previewTemplate: this.$refs.template.innerHTML,
      previewsContainer: `#dropzone-files`
    })

    this.dz.on('sending', function (file, xhr, formData) {
      $(file.previewElement).find('.progress').removeClass('hidden')
      $(file.previewElement).find('.remove-file').addClass('hidden')

      xhr.setRequestHeader('Authorization', `Bearer ${auth.getToken()}`)
    })

    this.dz.on('success', this.handleUploadSuccessCallback)
    this.dz.on('error', this.handleUploadErrorCallback)

    this.handleDefaultFilesCallback()
  },

  methods: {
    ...graduateMethods,

    /**
     * populate list with existing files
     */
    handleDefaultFilesCallback () {
      this.dz.removeAllFiles()

      each(this.graduate.documents, (file) => {
        let mock = {
          accepted: true,
          name: file.filename,
          id: file.id,
          user_id: file.user_id
        }

        this.dz.emit('addedfile', mock)
        this.dz.emit('success', mock)
        this.dz.emit('complete', mock)

        this.dz.files.push(mock)
      })
    },

    handleUploadErrorCallback (file, message) {
      let fileSizeLimit = this.dz.options.maxFilesize * 1024 * 1024

      $(file.previewElement).remove()

      if (message === `You can't upload files of this type.`) {
        this.$noty.error(`File type not supported, please upload a .docx or pdf under 5MB.`)
      } else if (file.size > fileSizeLimit) {
        this.$noty.error(`File size too large, please upload a .docx or pdf under 5MB`)
      } else {
        this.$noty.error('There was a problem uploading the file.')
      }
    },

    handleUploadSuccessCallback (file, response) {
      if (file.id === undefined || file.id === null) {
        file.id = response.data.id
        this.addDocument(response.data)
      }

      $(file.previewElement).find('.progress').addClass('hidden')
      $(file.previewElement).find('.remove-file').removeClass('hidden')

      this.bindDeleteFileEventHandler(file)
      this.bindDownloadFileEventHandler(file)
    },

    bindDeleteFileEventHandler (file) {
      if (this.$userIsAdmin) {
        $(file.previewElement)
          .find('a.remove-file')
          .on('click', (event) => {
            this.handleDeleteFileCallback(file)
          })
      }
    },

    bindDownloadFileEventHandler (file) {
      $(file.previewElement)
        .find('a.download-file')
        .on('click', (event) => {
          event.preventDefault()

          this.handleDownloadFileCallback(file)
        })
    },

    handleDownloadFileCallback (file) {
      if (file.id) {
        window.location.href = apiUrl(`graduates/${this.graduate.id}/documents/${file.id}`)
      }
    },

    async handleDeleteFileCallback (file) {
      if (file.id === undefined || file.id === null) {
        this.dz.removeFile(file)

        return
      }

      if (
        await alert.confirm({
          title: 'Delete File',
          text: 'Are you sure you want to delete this file?'
        })
      ) {
        await this.deleteDocument({ graduate: this.graduate.id, document: file.id })

        this.$noty.success('File deleted successfully.')

        this.dz.removeFile(file)
      }
    }
  }
}
</script>
